import React from "react";
import { ReactSetStateString } from "./FixedMargin";

function useFixedMarginSelector(
  setSuccess: ReactSetStateString,
  setErr: ReactSetStateString,
  setMargin: ReactSetStateString
) {
  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    setSuccess("");

    const withDecimal = value.includes(".");

    if (withDecimal) {
      const decimalPlaces = value.split(".")[1].length;
      if (decimalPlaces > 3) return;
    }

    if (value.includes("-") || value.includes("+") || value.includes("e")) {
      setErr("Please Enter a Positive Whole Number");
    } else {
      var marginI = parseInt(value);
      marginI > 99 && marginI ? setErr("Must be between 0 and 99") : setErr("");
    }

    setMargin(value);
  };

  return { handleChange };
}

export default useFixedMarginSelector;
